import { jsx as _jsx } from "react/jsx-runtime";
import withStyles from '@fil-react-components/with-styles';
import styles from './Heading.style';
const Heading = ({ children, className }) => {
    return _jsx("h1", Object.assign({ className: className }, { children: children }));
};
Heading.displayName = 'Heading';
export default withStyles(Heading, styles);
